var _excluded = ["children", "value"],
    _excluded2 = ["name", "onChange", "small", "selectedValue"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useContext } from 'react';
import { string, oneOfType, number } from 'prop-types';
import styled from 'styled-components';
import RadioGroupContext from '../../RadioGroupContext';
import { HiddenInput } from '../../../shared';
var Button = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n\n  min-width: 126px;\n  white-space: nowrap;\n\n  cursor: pointer;\n\n  ", "\n"])), function (_ref) {
  var radiogroup = _ref.theme.yoga.components.radiogroup,
      small = _ref.small,
      checked = _ref.checked;
  return "\n    box-sizing: border-box;\n    background-color: " + radiogroup.button.backgroundColor + ";\n    border-radius: " + radiogroup.button.border.radius + "px;\n\n    " + (checked ? "\n            background-color: " + radiogroup.checked.backgroundColor + ";\n            box-shadow: 0 0 0  " + radiogroup.button.border.width + "px " + radiogroup.checked.backgroundColor + ";\n            color: " + radiogroup.checked.font.color + ";\n            font-weight: " + radiogroup.checked.font.weight + ";\n            z-index: 1;\n          " : "\n          &:hover, &:focus {\n            background-color: " + radiogroup.hover.backgroundColor + ";\n          }\n        ") + "\n\n    font-size: " + radiogroup.font.size + "px;\n    height: " + (small ? radiogroup.button.height.small : radiogroup.button.height.normal) + "px;\n    padding-left: " + radiogroup.button.padding.left + "px;\n    padding-right: " + radiogroup.button.padding.right + "px;\n  ";
});
var ButtonWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  border-style: solid;\n\n  ", "\n"])), function (_ref2) {
  var radiogroup = _ref2.theme.yoga.components.radiogroup;
  return "\n    border-color: " + radiogroup.button.border.color + ";\n    border-top-width: " + radiogroup.button.border.width + "px;\n    border-bottom-width: " + radiogroup.button.border.width + "px;\n    \n    border-left: none;\n    border-right: none;\n    \n    &:first-child {\n      border-right-width: 0;\n      border-left-width: " + radiogroup.button.border.width + "px;\n      border-left-style: solid;\n      border-left-color: " + radiogroup.button.border.color + ";\n\n      border-top-left-radius: " + radiogroup.button.border.radius + "px;\n      border-bottom-left-radius: " + radiogroup.button.border.radius + "px;\n    }\n  \n    &:last-child {\n      border-left-width: 0;\n\n      border-right-width: " + radiogroup.button.border.width + "px;\n      border-right-style: solid;\n      border-right-color: " + radiogroup.button.border.color + ";\n\n      border-top-right-radius: " + radiogroup.button.border.radius + "px;\n      border-bottom-right-radius: " + radiogroup.button.border.radius + "px;\n    }\n  ";
});
/** Radio group allows user to select one option from a set of options. Use
value on group to set the selected option. */

var RadioGroupButton = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      value = _ref3.value,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded);

  var _useContext = useContext(RadioGroupContext),
      name = _useContext.name,
      onChange = _useContext.onChange,
      small = _useContext.small,
      selectedValue = _useContext.selectedValue,
      context = _objectWithoutPropertiesLoose(_useContext, _excluded2);

  var inputValue = value || children;
  var checked = inputValue === selectedValue;
  return /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    small: small,
    checked: checked
  }, /*#__PURE__*/React.createElement(HiddenInput, _extends({
    type: "radio",
    value: inputValue,
    checked: checked,
    name: name,
    onChange: onChange,
    ref: ref
  }, rest, context)), children));
});
RadioGroupButton.displayName = 'RadioGroup.Button';
RadioGroupButton.propTypes = {
  children: oneOfType([string, number]).isRequired,
  value: oneOfType([string, number])
};
RadioGroupButton.defaultProps = {
  value: ''
};
export default RadioGroupButton;